import { styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';

export const DataGridProStyled = styled(DataGridPro)(({ theme }) => ({
  [`&.${gridClasses.root}`]: {
    borderWidth: 0,
    '--DataGrid-rowBorderColor': 'none',
  },
  [`& .${gridClasses.columnHeaderTitleContainerContent}`]: {
    ...theme.typography.subtitle2,
    lineHeight: 1.2,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
    outline: 'none',
  },
  [`& .${gridClasses.cell}, & .${gridClasses.columnHeader}`]: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 30,
    paddingRight: 30,
    borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
  },
})) as typeof DataGridPro;
